import {get, post} from 'utils/axios'
import {AxiosError} from 'axios'
import {handleRejectedErrorMsg} from 'utils/helpers/handleError'
import {
 BulkUploadTemplateResponse,
 FetchBulkUploadParams,
} from 'models/BulkUpload'
import {IFormField} from 'models/Common'
import ApiResponse from 'models/ApiResponse'
import IDropdownVal from 'models/dropdown'
import {toast} from 'react-toastify'

interface IFetchOrganisationParams {
 type: string
 state?: number
 district?: number
}

const fetchBulkUploadListApi = async (
 params: FetchBulkUploadParams
) => {
 try {
  const {page = 1, page_size = 10, ...restParams} = params

  const queryParams: IFormField = {
   page,
   page_size,
   ...restParams,
  }

  const res = await get('/bulk-upload/list/', queryParams)

  return res
 } catch (err) {
  return {
   count: 0,
   next: null,
   previous: null,
   results: [],
  }
 }
}
const bulkUploadApi = async (
 bulk_upload_type: string,
 file: File,
 aggregator_org_id: string,
 parent_id?: string | number
) => {
 try {
  const formData = new FormData()

  formData.append('file', file)

  formData.append(
   'meta_data',
   JSON.stringify({
    aggregator_org_id,
   })
  )

  if (parent_id) {
   formData.append('parent_id', String(parent_id))
  }

  const res = await post(
   `/bulk-upload/${bulk_upload_type}/`,
   formData
  )

  return res
 } catch (err) {
  const error = err as AxiosError
  toast.error(
   error.response?.data?.message || 'Something went wrong'
  )
  return error.response?.data
 }
}
const getBulkUploadTemplateApi = async (
 upload_type: string
): Promise<{
 success: boolean
 data?: {
  upload_type: string
  tempalte_filename: string
  template_url: string
 }
} | null> => {
 try {
  const res = await get<BulkUploadTemplateResponse>(
   '/bulk-upload/get-template',
   {
    upload_type,
   }
  )

  return res
 } catch (err) {
  const error = err as AxiosError
  handleRejectedErrorMsg(error)
  return null
 }
}

const fetchBulkUploadOrganisation = async ({
 type,
 state,
 district,
}: IFetchOrganisationParams) => {
 try {
  return await get<ApiResponse<IDropdownVal>>(
   `/rb/v1/organisations`,
   {
    type,
    ...(state && {state}),
    ...(district && {district}),
   }
  ).then((res) => {
   if (res) {
    return res?.data
   } else {
    toast.error('Something went wrong')
    return []
   }
  })
 } catch (err: unknown) {
  const e = err as AxiosError
  handleRejectedErrorMsg(e)
  return []
 }
}

export {
 fetchBulkUploadListApi,
 bulkUploadApi,
 getBulkUploadTemplateApi,
 fetchBulkUploadOrganisation,
}
